export var valuesChatMessageEvent = ["UserJoined", "UserLeft", "UserPromoted", "UserDemoted", "MessageDeleted", "ChatNameChanged", "ChatImageChanged"];
/*

*/ 
//# sourceMappingURL=ChatMessageEvent.js.map